import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';

import * as $ from 'jquery';
import 'multiple-select/dist/multiple-select.min.js'


import 'multiple-select/dist/multiple-select.min.css';

import './form-item-paia-request.component.scss';

export class FormItemPaiaRequest extends Base {
	// form
	form: HTMLFormElement;
	steps: HTMLFormElement[];

	// form sections
	formLoader: Element;
	formFields: Element;
	formThankyou: Element;
	timeout: any;
	customHeading: HTMLFormElement;

	// inputs
	requesteeInfo: HTMLFormElement[];
	thirdPartyCheck: HTMLFormElement[];
	requesterSACitizen: HTMLFormElement[];
	requesterId: HTMLFormElement;
	requesterQuestion: HTMLFormElement;
	requesteeSACitizen: HTMLFormElement[];
	requesteeId: HTMLFormElement;
	responseTypeSelect: HTMLFormElement;
	responseTypeInput: HTMLFormElement;

	// buttons
	buttonSubmit: Element;
	stepButtons: Element[];
	prevButtons: Element[];

	// wizard count
	wizardCount: Element;
	bulletContainer: Element;
	totalSteps: Element;

	// hidden
	hidLeadId: any;
	hidProduct: any;
	hidCallMeBackModalId: any;

	multiSelect: any;

	responseTypes = [{
		value: 'personal',
		text: 'In my personal capacity'
	}, {
		value: 'legal',
		text: 'Legal representative of the requester employee'
	}, {
		value: 'employee',
		text: 'Employee of the requester'
	}, {
		value: 'officer',
		text: 'Information Officer of the requester'
	}, {
		value: 'nextofkin',
		text: 'Next of kin for a deceased individual'
	}, {
		value: 'executor',
		text: 'Executor of a deceased estate'
	}, {
		value: 'business',
		text: 'Representative of a Juristic Entity'
	}, {
		value: 'other',
		text: 'Other (Auditor, Financial Advisor, Family member of a living requester)'
	}];

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.formLoader = this.element.querySelector(".form__loader--container");
		this.formFields = this.element.querySelector(".form__fields--container");
		this.formThankyou = this.element.querySelector(".form__thankyou--container");
		this.customHeading = this.element.querySelector(".customHeading");

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.steps = Array.from(this.element.querySelectorAll(".paia-request__steps--step[data-step]"));
		this.buttonSubmit = this.element.querySelector('.js_paia-step-submit-button');
		this.stepButtons = Array.from(this.element.querySelectorAll(".js_paia-step-button"));
		this.prevButtons = Array.from(this.element.querySelectorAll(".js_paia-step-prev-button"));

		this.hidLeadId = this.form.querySelector('input[name=leadId]');
		this.hidProduct = this.form.querySelector('input[name=product]');
		this.responseTypeSelect = this.form.querySelector('select[name=selectedResponse]');
		this.responseTypeInput = this.form.querySelector('input[name=requesterRole]');

		this.wizardCount = this.element.querySelector(".paia-request__counter--count");
		this.bulletContainer = this.element.querySelector(".paia-request__bullets");

		this.totalSteps = this.element.querySelector('input[name="total-steps"]');
		this.totalSteps.nodeValue = this.steps.length.toString();
		this.showStep(1);

		$(document).ready(function () {
			$('.paia-multi-select').multipleSelect({ placeholder: 'Please select', selectAll: false });
		});
		this.requesteeInfo = Array.from(this.element.querySelectorAll('.requestee-info'));
		if (this.requesteeInfo) {
			this.requesteeInformation('hide');
		}
		this.requesterSACitizen = Array.from(this.element.querySelectorAll('input[name=requesterIsSouthAfrican]'));
		this.requesterId = this.element.querySelector("input[name=requesterIdentificationNumber]");
		this.requesterQuestion = this.element.querySelector("input[name=requesterIsSouthAfrican]");
		this.requesteeSACitizen = Array.from(this.element.querySelectorAll('input[name=requesteeIsSouthAfrican]'));
		this.requesteeId = this.element.querySelector("input[name=requesteeIdentificationNumber]");

		this.thirdPartyCheck = Array.from(this.element.querySelectorAll("input[name=isThirdParty]"));
	}

	bindEvents() {

		if (this.buttonSubmit) {
			this.buttonSubmit.addEventListener('click', (event) => {
				const _button = event.target as HTMLFormElement;
				const _form = _button.closest('form') as HTMLFormElement;
				const formFields: any = _form.querySelectorAll('input:not([data-name]), select, textarea');
				this.validationService.validate(formFields);
				const valid = Array.from(_form.querySelectorAll(".form__group--error"));
				if (valid.length == 0) {
					this.submitForm(_form);
				}
			});
		}

		if (this.stepButtons.length) {
			this.stepButtons.map((item) => item.addEventListener('click', (event) => {
				const _event: any = event.currentTarget;
				const _currentStep = _event.closest(".paia-request__steps--step");
				if (!_currentStep.classList.contains("paia-request__steps--hidden")) {
					const formFields: any = _currentStep.querySelectorAll('input, select, textarea');
					this.validationService.validate(formFields);
					const valid = Array.from(_currentStep.querySelectorAll(".form__group--error"));
					if (valid.length == 0) {
						this.showNextStep(event);
					}
				}
			}));
		}

		if (this.prevButtons.length) {
			this.prevButtons.map((item) => item.addEventListener('click', (event) => {
				const _event: any = event.currentTarget;
				const _currentStep = _event.closest(".paia-request__steps--step");
				if (!_currentStep.classList.contains("paia-request__steps--hidden")) {
					this.showPrevStep(event);
				}
			}));
		}

		if (this.responseTypeSelect) {
			this.responseTypeSelect.addEventListener('change', (pEvent: any) => {
				let _tmpOption = pEvent.target.value;
				const _tmpValue = this.responseTypes.find(pType => {
					if (pType.value == _tmpOption) {
						return pType;
					}
				});
				if (_tmpOption == 'personal') {
					this.requesteeInformation('hide', 'personal');
				} else {
					this.requesteeInformation('show', 'personal');
				}

				if (_tmpOption == 'business') {
					this.showIdNumber('hide', this.requesterQuestion);
				} else {
					this.showIdNumber('show', this.requesterQuestion);
				}
				if (_tmpValue) {
					this.responseTypeInput.value = _tmpValue.text;
				}
			});
		}

		if (this.thirdPartyCheck) {
			this.thirdPartyCheck.map((item) => item.addEventListener('click', (event) => {
				const evt: any = event.target;
				const checkAnswer: any = evt.value;

				if (checkAnswer === 'Yes') {
					this.requesteeInformation('show');
				} else {
					this.requesteeInformation('hide');
				}
			}));
		}

		if (this.requesterSACitizen) {
			this.requesterSACitizen.map((item) => item.addEventListener('click', (event) => {
				const evt: any = event.target;
				const checkAnswer: any = evt.value;

				if (checkAnswer === 'Yes') {
					this.showIdNumber('show', this.requesterId);
				} else {
					this.showIdNumber('hide', this.requesterId);
				}
			}));
		}

		if (this.requesteeSACitizen) {
			this.requesteeSACitizen.map((item) => item.addEventListener('click', (event) => {
				const evt: any = event.target;
				const checkAnswer: any = evt.value;

				if (checkAnswer === 'Yes') {
					this.showIdNumber('show', this.requesteeId);
				} else {
					this.showIdNumber('hide', this.requesteeId);
				}
			}));
		}

		// Reset the form
		this.form.addEventListener('custom_form_reset_event', (e) => {
			const thirdParty = this.element.querySelector(".form__success--container-thirdParty");
			if (thirdParty) {
				thirdParty.classList.remove("active");
			}

			const success = this.element.querySelector(".form__success--container");
			if (success) {
				success.classList.remove("active");
			}
			this.showIdNumber('hide', this.requesteeId);
			this.showIdNumber('hide', this.requesterId);
			this.requesteeInformation('hide');
			this.showStep(1);
			const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
			valid.map(pElem => {
				pElem.classList.remove('form__group--error');
				const errorMessage = pElem.querySelector(".form__group--error_message");
				if (errorMessage) {
					errorMessage.remove();
				}
			});
			$('.paia-multi-select:selected').prop("selected", false);
			$('.paia-multi-select').multipleSelect("refresh");
		}, false);
	}

	requesteeInformation(state: any, personal?: string) {
		if (this.requesteeInfo) {
			if (state == 'show') {
				this.requesteeInfo.map(pElem => {
					if (!pElem.classList.contains("paia-request_requesteeId")) {
						pElem.classList.remove("form__group--hidden");
					}
				});
			} else {
				this.requesteeInfo.map(pElem => {
					if (!personal) {
						pElem.classList.add("form__group--hidden");
					} else if (personal) {
						if (!pElem.classList.contains('paia-request__responseType')) {
							pElem.classList.add("form__group--hidden");
						}
					}
				});
			}
		}
	}

	showIdNumber(state: any, pElement: any) {
		if (this.requesteeInfo) {
			if (state == 'show') {
				const _parent = pElement.closest('.form__group');
				_parent.classList.remove("form__group--hidden");
			} else {
				const _parent = pElement.closest('.form__group');
				_parent.classList.add("form__group--hidden");
			}
		}
	}

	showStep(stepId) {
		const _currentstep = this.element.querySelector("[data-step='" + stepId + "']");
		const _heading: any = _currentstep.getAttribute("data-heading");
		if (_heading) {
			const _h3Heading = this.customHeading.querySelector("h3");
			_h3Heading.innerHTML = _heading;
		}
		const _listItems = document.createElement('ul');
		_listItems.classList.add("paia-request__bullets-container");
		if (this.steps) {
			this.steps.forEach((element, index) => {
				const _step = element.getAttribute("data-step");
				const _label: any = element.getAttribute("data-label");
				const _listItem = document.createElement('li');
				if ((parseFloat(_step) == stepId)) {
					element.classList.remove("paia-request__steps--hidden");
					_listItem.classList.add("paia-request__bullets-container--bullet");
					_listItem.classList.add("paia-request__bullets-container--bullet--active");
				} else {
					element.classList.add("paia-request__steps--hidden");
					_listItem.classList.add("paia-request__bullets-container--bullet");
				}
				_listItem.innerHTML = "&bull;";

				const _listLabel = document.createElement('div');
				_listLabel.classList.add("paia-request__bullets-container--bullet-label");
				_listLabel.innerHTML = _label;
				_listItem.appendChild(_listLabel);

				_listItems.appendChild(_listItem);

				if (index < (this.steps.length - 1)) {
					const _listPipe = document.createElement('li');
					_listPipe.classList.add("paia-request__bullets-container--bullet");
					_listPipe.classList.add("paia-request__bullets-container--bullet--link");
					_listPipe.innerHTML = "&nbsp;";
					_listItems.appendChild(_listPipe);
				}
			});
		}
		if (this.wizardCount) {
			this.wizardCount.innerHTML = stepId + "/" + parseFloat(this.totalSteps.getAttribute('value'));
		}
		if (this.bulletContainer) {
			this.bulletContainer.innerHTML = "";
			this.bulletContainer.appendChild(_listItems);
		}
		//this.updateForm(this.applicationType.value);
	}

	showNextStep(event) {
		const _target = event.currentTarget;
		const _currentStep = _target.closest("[data-step]");
		const _nextStep = _currentStep.getAttribute("data-step");

		this.showStep(parseFloat(_nextStep) + 1);
	}

	showPrevStep(event) {
		const _target = event.currentTarget;
		const _currentStep = _target.closest("[data-step]");
		const _nextStep = _currentStep.getAttribute("data-step");
		if (parseFloat(_nextStep) > 0) {
			this.showStep(parseFloat(_nextStep));
		} else {
			this.showStep(1);
		}
	}

	submitForm(form: HTMLFormElement) {
		// success screens
		const loader = form.querySelector('.form__loader--container');
		const thankYou = form.querySelector('.form__thankyou--container');
		const success = form.querySelector('.form__success--container');
		const successThirdParty = form.querySelector('.form__success--container-thirdParty');
		const error = form.querySelector('.form__error--container');
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		let name: HTMLFormElement[] = Array.from(form.querySelectorAll('.form__success-container__firstname'));
		let referenceNumber: HTMLFormElement = form.querySelector('.form__success-container__reference');

		let postData = '';

		let isThirdParty: any = this.form.querySelector('input[name=isThirdParty]');
		let isThirdPartyChecked: any = this.form.querySelector('input[name=isThirdParty]:checked');
		if (isThirdParty) {
			postData += "isThirdParty=" + isThirdPartyChecked.value;
		}
		let requesterRole: any = form.querySelector("input[name=requesterRole]");
		if (requesterRole) {
			postData += "&requesterRole=" + requesterRole.value;
		}
		let selectedResponse: any = form.querySelector("select[name=selectedResponse]");
		if (selectedResponse) {
			postData += "&selectedResponse=" + selectedResponse.value;
		}
		let requesteeFirstName: any = this.form.querySelector('input[name=requesteeFirstName]');
		if (requesteeFirstName) {
			postData += "&requesteeFirstName=" + requesteeFirstName.value;
		}
		let requesteeLastName: any = this.form.querySelector('input[name=requesteeLastName]');
		if (requesteeLastName) {
			postData += "&requesteeLastName=" + requesteeLastName.value;
		}
		let requesteeIsSouthAfrican: any = this.form.querySelector('input[name=requesteeIsSouthAfrican]');
		if (requesteeIsSouthAfrican) {
			let requesteeIsSouthAfricanChecked: any = this.form.querySelector('input[name=requesteeIsSouthAfrican]:checked');
			postData += "&requesteeIsSouthAfrican=" + requesteeIsSouthAfricanChecked.value;
		}
		let requesteeContactNumber: any = this.form.querySelector('input[name=requesteeContactNumber]');
		if (requesteeContactNumber) {
			postData += "&requesteeContactNumber=" + requesteeContactNumber.value;
		}
		let requesteeIdentificationNumber: any = this.form.querySelector('input[name=requesteeIdentificationNumber]');
		if (requesteeIdentificationNumber) {
			postData += "&requesteeIdentificationNumber=" + requesteeIdentificationNumber.value;
		}
		let requesteeEmailAddress: any = this.form.querySelector('input[name=requesteeEmailAddress]');
		if (requesteeEmailAddress) {
			postData += "&requesteeEmailAddress=" + requesteeEmailAddress.value;
		}
		let requesterFirstName: any = this.form.querySelector('input[name=requesterFirstName]');
		if (requesterFirstName) {
			postData += "&requesterFirstName=" + requesterFirstName.value;
		}
		let requesterLastName: any = this.form.querySelector('input[name=requesterLastName]');
		if (requesterLastName) {
			postData += "&requesterLastName=" + requesterLastName.value;
		}
		let requesterIsSouthAfrican: any = this.form.querySelector('input[name=requesterIsSouthAfrican]');
		if (requesterIsSouthAfrican) {
			let requesterIsSouthAfricanChecked: any = this.form.querySelector('input[name=requesterIsSouthAfrican]:checked');
			postData += "&requesterIsSouthAfrican=" + requesterIsSouthAfricanChecked.value;
		}
		let requesterIdentificationNumber: any = this.form.querySelector('input[name=requesterIdentificationNumber]');
		if (requesterIdentificationNumber) {
			postData += "&requesterIdentificationNumber=" + requesterIdentificationNumber.value;
		}
		let requesterContactNumber: any = this.form.querySelector('input[name=requesterContactNumber]');
		if (requesterContactNumber) {
			postData += "&requesterContactNumber=" + requesterContactNumber.value;
		}
		let requesterEmailAddress: any = this.form.querySelector('input[name=requesterEmailAddress]');
		if (requesterEmailAddress) {
			postData += "&requesterEmailAddress=" + requesterEmailAddress.value;
		}
		let consentIndicator: any = this.form.querySelector('input[name=consentIndicator]');
		if (consentIndicator) {
			postData += "&consentIndicator=" + consentIndicator.value;
		}
		let requestedInformationDetails: any = this.form.querySelector('textarea[name=requestedInformationDetails]');
		if (requestedInformationDetails) {
			postData += "&requestedInformationDetails=" + requestedInformationDetails.value;
		}
		let legalRightsInformationDetails: any = form.querySelector("textarea[name=legalRightsInformationDetails]");
		if (legalRightsInformationDetails) {
			postData += "&legalRightsInformationDetails=" + legalRightsInformationDetails.value;
		}
		let responseFormat: any = form.querySelector("select[name=responseFormat]");
		if (responseFormat) {
			let options = '';
			for (let i = 0; i < responseFormat.options.length; i++) {
				if (responseFormat.options[i].selected) {
					options += responseFormat.options[i].value + ',';
				}
			}
			options = options.substring(0, options.length - 1);
			postData += "&responseFormat=" + options;
		}
		let requestReason: any = form.querySelector("select[name=requestReason]");
		if (requestReason) {
			postData += "&requestReason=" + requestReason.value;
		}
		let destinationEmailAddress: any = form.querySelector("input[name=email]");
		if (destinationEmailAddress) {
			postData += "&email=" + destinationEmailAddress.value;
		}
		let emailSubject: any = form.querySelector("input[name=subject]");
		if (emailSubject) {
			postData += "&emailSubject=" + emailSubject.value;
		}
		if (isThirdPartyChecked.value == "Yes") {
			postData += "&ccEmailAddresses=" + destinationEmailAddress.value + ',' + requesterEmailAddress.value;
		} else {
			postData += "&ccEmailAddresses=" + destinationEmailAddress.value;
		}
		let bccAddresses: any = form.querySelector("input[name=recipient]");
		if (bccAddresses) {
			postData += "&bccAddresses=" + bccAddresses.value;
		}
		let serviceType: any = form.querySelector("input[name=service-type]");
		if (serviceType) {
			postData += "&service-type=" + serviceType.value;
		}

		// loader + hide form
		this.formLoader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/PromotionToPersonalInformationAct.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then((response: any) => {
			this.formLoader.classList.remove('active');
			if (!response.data || (String(response.data).match(/(invalid)/gi))) {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				this.formThankyou.classList.add('active');
				error.classList.add('active');
			} else if (response.data.success) {
				if (name) {
					name.map((_item) => {
						_item.innerHTML = requesterFirstName.value;
					});
				}
				if (referenceNumber && response.data.referenceNumber) {
					referenceNumber.innerHTML = response.data.referenceNumber;
				}
				analyticsService.dtmFormComplete('complete', response.code);
				this.formThankyou.classList.add('active');
				let isThirdPartyChecked: any = this.form.querySelector('input[name=isThirdParty]:checked');
				if (isThirdPartyChecked && (isThirdPartyChecked.value == 'Yes')) {
					success.classList.add('active');
				} else {
					successThirdParty.classList.add('active');
				}
			} else {
				analyticsService.dtmFormComplete('complete', 'false');
				this.formLoader.classList.remove('active');
				fieldsContainer.classList.remove('hidden');
			}
		}).catch(response => {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			this.formLoader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
	}
}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-paia-request/form-item-paia-request.component.ts